import React from 'react';

// Styles & Assets
import styles from './PreconfigActionButton.module.css';
import { Link, LinkProps } from 'react-router-dom';

// Interfaces 
interface PropsButton {
    type: 'button'
    onClick: (evt: React.FormEvent) => void
    children: React.ReactNode
    disabled?: boolean
}

interface PropsLink {
    type: 'link'
    to: LinkProps['to'];
    state?: LinkProps['state'];
    children: React.ReactNode
}

type Props = PropsLink | PropsButton

const PreconfigActionButton: React.FC<Props> = (props) => {

    if (props.type === 'link') {
        const { to, state, ...rest } = props;
        return (
            <Link to={to} state={state} className={styles.buttonIcon} {...rest}>
                {props.children}
            </Link>
        );
    }

    const { onClick, disabled, ...rest } = props;
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={styles.buttonIcon}
            {...rest}
        >
            {props.children}
        </button>
    );
};

export default PreconfigActionButton;